An opaque cursor to the earlier bounding hirer.

Resulting hirers will be alphabetically later than this cursor.
